import { HttpClient } from "@/App/services";
import { UserQueryResult } from "@/Users/types";

export default {
  getData(emsAgencyId: String) {
    return HttpClient.get({ path: `/emsAgencies/${emsAgencyId}?fields=members,administrators` }).then(
      ({ data }) => data
    );
  },
  insertData(payload: any) {
    return HttpClient.post({ path: "/users", data: payload });
  },
  updateData(userId: String, payload: any) {
    return HttpClient.put(`/users/${userId}`, payload);
  },
  deleteData(emsAgencyId: String, recordId: String, role: String) {
    return HttpClient.delete(`/emsAgencies/${emsAgencyId}/${role}s?userId=${recordId}`);
  },
  checkEmail(email: string): Promise<UserQueryResult[]> {
    return HttpClient.get({ path: FIND_USER_BY_EMAIL(email) }).then(({ data }) => data);
  },
  addExistingUser(emsAgencyId: String, userId: String, role: String) {
    return HttpClient.post({
      path: `/emsAgencies/${emsAgencyId}/members?emsAgencyId=${emsAgencyId}&roleId=${role}&userId=${userId}`
    });
  },
  sendWelcomeEmail({ username }): Promise<any> {
    return HttpClient.post({
      path: "/welcome",
      data: { username }
    });
  },
  findByUsername(username): Promise<UserQueryResult[]> {
    return HttpClient.get({
      path: FIND_USER_BY_USERNAME(username)
    }).then(({ data }) => data);
  }
};

const FIND_USER_BY_USERNAME = (username: string): string => `/users?or=[exactUsername=${encodeURIComponent(username)}]`;
const FIND_USER_BY_EMAIL = (email: string): string => `/users?or=[exactEmail=${encodeURIComponent(email)}]`;
